import {inject, Injectable} from '@angular/core';
import {ThirdPartyLicenseDataService} from './third-party-license-data.service';
import {Observable} from 'rxjs';
import {Page} from '@uofu-uss/angular-util';

export interface ThirdPartyLicense {
  id: number;
  auto: boolean;
  launchLink: string;
  name: string;
  vendorName: string;
}

export function emptyThirdPartyLicense(): ThirdPartyLicense {
  return {
    id: 0,
    auto: false,
    launchLink: '',
    name: '',
    vendorName: '',
  };
}

@Injectable({
  providedIn: 'root'
})
export class ThirdPartyLicenseService {

  private readonly dataService = inject(ThirdPartyLicenseDataService);

  search(vendorName = '', name = ''): Observable<Page<ThirdPartyLicense>> {
    return this.dataService.search(vendorName, name);
  }
}
